// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"656":"958ca5fb","795":"e1354fbf"}[chunkId] + ".chunk.js";
};